import { useState, useEffect } from "react";
import axios from "axios";
import ProgressBar from "./ProgressBar";

const baseUrl = process.env.REACT_APP_PUBLIC_API_URL

const Top5Regions = () => {
  const [top5Regions, setTop5Regions] = useState([]);
  const [engagementData, setEngagementData] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/top-regions`)
      .then((response) => {
        const resData = response.data;
        if (resData.success && Array.isArray(resData.top5Regions)) {
          setTop5Regions(resData.top5Regions);
        }
      })
      .catch((error) => console.error("Error fetching top regions:", error));
  }, []);

  useEffect(() => {
    axios
      .get(`${baseUrl}/current-engagement`)
      .then((response) => {
        const resData = response.data;
        if (resData.success && Array.isArray(resData.engagement)) {
          setEngagementData(resData.engagement);
        }
      })
      .catch((error) => console.error("Error fetching current engagement:", error));
  }, []);



  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <h2 className="text-lg font-semibold mb-1">Top 5 Regions</h2>

      <div className="flex justify-between text-sm mb-4">
        <span className="text-gray-500">By Registration</span>
      </div>

      <div className="space-y-4">
        {top5Regions.length > 0 ? (
          top5Regions.map((item) => (
            <div key={item.name}>
              <div className="flex justify-between text-sm mb-1">
                <span>{item.name}</span>
                <span className="text-green-700 font-semibold">
                  {item.count.toLocaleString()} ({item.percent}%)
                </span>
              </div>
              <ProgressBar value={item.percent} />
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-500">No region data yet.</p>
        )}
      </div>

      <hr className="my-6" />

      <h2 className="font-medium mb-4">Current Engagement</h2>
      <span className="text-gray-500">How Youth is Involved in Agric</span>
      <div className="space-y-4">
        {engagementData.length > 0 ? (
          engagementData.map((item) => (
            <div key={item.name}>
              <div className="flex justify-between text-sm mb-1">
                <span>{item.name}</span>
                <span className="text-green-700 font-semibold">
                  {item.percent}%
                </span>
              </div>
              <ProgressBar value={item.percent} />
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-500">No engagement data yet.</p>
        )}
      </div>
    </div>
  );
};

export default Top5Regions;
